export const BRAND = "Shine Solutions";
export const PHONE = "623-270-0524";
export const PHONE_HREF = "tel:+16232700524";
export const EMAIL = "admin@theshinesolution.com";
export const EMAIL_HREF = `mailto:${EMAIL}`;
export const HOURS = "Monday–Friday, 8 a.m.–7 p.m.";
export const CITIES = ["Peoria", "Glendale", "Surprise"];
export const BK_FORM_URL = process.env.REACT_APP_BOOKINGKOALA_FORM_URL || "";
export const SITE_URL = process.env.REACT_APP_SITE_URL || "";

export const PILLARS = [
  { t: "Reliability", d: "Visits planned on an agreed day and service window, managed in one scheduling system." },
  { t: "Professionalism", d: "A commercial cleaning partner with written scopes and discreet service around your hours." },
  { t: "Consistency", d: "A documented checklist for recurring visits, so standards hold over time." },
  { t: "Accountability", d: "One accountable point of contact for your account, not a call center." },
  { t: "Communication", d: "Confirmations, reminders and follow-ups through a single client channel." },
  { t: "Quality", d: "Work reviewed against your written scope, with follow-up when something needs attention." },
];

export const STEPS = [
  { t: "Request a quote", d: "Tell us about your facility, the services you need and how often. Your request is reviewed by our team — no automatic pricing." },
  { t: "Walkthrough or consultation", d: "We schedule a facility walkthrough or a consultation call to confirm the scope, access and service windows." },
  { t: "Customized proposal", d: "You receive a written proposal built for your facility: scope by area, visit frequency, service windows and pricing." },
  { t: "Recurring service begins", d: "Once you approve, your recurring schedule is set up and service begins. Nothing is booked or charged before approval." },
];

export const AUDIENCES = [
  { t: "Corporate & professional offices", d: "Headquarters, branch offices and professional services firms." },
  { t: "Retail stores & showrooms", d: "Sales floors, display areas and customer-facing spaces." },
  { t: "Medical & dental office facilities", d: "Patient-facing and staff areas of outpatient practices." },
  { t: "Multi-tenant commercial properties", d: "Lobbies, corridors and shared areas for property managers." },
  { t: "Small & midsize commercial facilities", d: "Business parks, flex spaces and light-commercial sites." },
];
